import React from 'react';
import Manager from './Manager';
import { useLanguage } from '@base/LanguageProvider';
import FSButton from '@components/FSButton';
import { ModalFooterStyled } from '@styled/Modal';
export default function ModalFooter(_a) {
    var done = _a.done, doneLabel = _a.doneLabel, cancelLabel = _a.cancelLabel, _b = _a.loading, loading = _b === void 0 ? false : _b, doneColor = _a.doneColor;
    var L = useLanguage().L;
    return (React.createElement(ModalFooterStyled, null,
        React.createElement(FSButton, { "$type": "tertiary", type: "button", title: cancelLabel ? cancelLabel : L('Cancel'), onClick: Manager.closeModal }),
        React.createElement(FSButton, { type: "submit", "$color": doneColor, loading: loading, title: doneLabel ? doneLabel : L('Save'), onClick: done })));
}
